import {FC} from "react";
import Typography from "@mui/material/Typography";
import {alpha, Grid, Link, Stack} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import {Link as RouterLink} from "react-router-dom";


interface IFooterLinks {
    title: string,
    links: { label: string, path: string }[]
}

interface IProps {
    footerLinks: IFooterLinks
}

const FooterLinks: FC<IProps> = (props) => {
    const theme = useTheme()

    const linkStyles = {
        fontSize: '0.875rem',
        textDecoration: 'none',
        color: alpha(theme.palette.primary.main, .7),
        '&:hover': {
            color: theme.palette.primary.main,
            textDecoration: 'underline',
            cursor: 'pointer'
        },
    }

    return (
        <Grid item>
            <Typography variant='button' color="primary" fontWeight='bold'>{props.footerLinks.title}</Typography>
            <Stack>
                {props.footerLinks.links.map((l) => (
                    !l.path.includes('http') ?
                        <Link key={l.path} component={RouterLink} to={l.path} sx={linkStyles}>{l.label}</Link> :
                        <Link key={l.path} href={l.path} sx={linkStyles} target="_blank"
                              rel="noopener noreferrer">{l.label}</Link>
                ))}
            </Stack>
        </Grid>
    )
}

export default FooterLinks
